export default "__VITE_ASSET__d8db129b__"